if (typeof mapboxgl !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    var mapElement = document.getElementById('mapbox-map');
    if (!mapElement) return;
    mapboxgl.accessToken = 'pk.eyJ1IjoiaWFtcmFodWxtIiwiYSI6ImNtYmxzdXV1ZjAwa2cybHB2ODhyMnZ6NmQifQ.jrjoFPAx8Q3AOMjFv7Q5Gg';
    var coordinates = [151.171, -33.891];
    var map = new mapboxgl.Map({
      container: 'mapbox-map',
      style: 'mapbox://styles/mapbox/light-v11',
      center: coordinates,
      zoom: 10
    });
    new mapboxgl.Marker().setLngLat(coordinates).addTo(map);
  });
}
